import {Helmet} from "react-helmet";
import React from "react";
import {getBahabinText, getSymbolFromFullSymbol} from "./DominantUtil.js"

export const MAX_TITLE_LENGTH = 48;
export const MAX_META_DESCRIPTION_LENGTH = 148;

export const makeStockHelmet = ({s = "", faN = "", market = "", assetType = ""}) => getHelmet(
    {
        title: limitString(
            getStockPageTitle({
                s: s,
                market: market,
                faN: faN,
                assetType: assetType
            }), MAX_TITLE_LENGTH) + getBahabinText(),
        description: limitString(getMetaDescription({
            s: s,
            market: market,
            faN: faN,
            assetType: assetType
        }), MAX_META_DESCRIPTION_LENGTH) + 'در بهابین'
    });

export const getHelmet = ({title, description}) => <Helmet title={title}
                                                           meta={[{
                                                               name: 'description',
                                                               content: description
                                                           }, {
                                                               name: 'og:description',
                                                               content: description
                                                           }, {
                                                               property: 'twitter:description',
                                                               content: description
                                                           }, {
                                                               property: 'og:title',
                                                               content: title
                                                           }, {
                                                               property: 'twitter:title',
                                                               content: title
                                                           },
                                                           ]}
/>;

export const getStockPageTitle = ({s = "", faN = "", market = ""}) =>
    `قیمت و خبرهای ${s ? s : ''} (${faN}) - نمودار تاریخی و تحلیل تکنیکال ${market}`

export const getMetaDescription = ({s = "", faN = "", market = "", assetType = ""}) =>
    `قیمت ${assetType} ${s ? s : ''}، نماد ${faN}، آخرین اخبار بازار ${market}، نمودار تاریخی، نمودار تکنیکال و ارزش لحظه‌ای ${assetType} `

export const limitString = (str, maxLength) => (str.length > maxLength) ?
    str.substring(0, maxLength - 3) + '...' :
    str;